export default {
    name: 'productComparer',
    products: 'products',
};
